// extracted by mini-css-extract-plugin
export default {"logo":"Navbar_logo__dHzLT","cartWrapper":"Navbar_cartWrapper__dDkNI","icHome":"Navbar_icHome__I3DiX","icAnim":"Navbar_icAnim__-3Ant","scaleIn":"Navbar_scaleIn__-zwxB"};